import { Close } from '@mui/icons-material'
import { Grid2, IconButton, Typography } from '@mui/material'
import { Dispatch, SetStateAction } from 'react'
import OrderChat from '../../../components/OrderChat'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useApp } from '../../../contexts/AppContext'

const DashboardOrderChat = ({ setOpenOrderChat }: { setOpenOrderChat: Dispatch<SetStateAction<boolean>> }) => {
    const [searchParams] = useSearchParams()
    const navigate = useNavigate();
    const {translate} = useApp()

    const order_id = searchParams.get('order_id');

    if (!order_id) {
        navigate(-1)
        return null;
    }

    return (
        <Grid2 container flexDirection={'column'} padding={2} gap={1} height={'100%'} wrap='nowrap'>
            <Grid2 container size={'auto'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                <Grid2>
                    <Typography variant='h5'>
                        {translate("Customer Support")}
                    </Typography>
                </Grid2>

                <Grid2>
                    <IconButton onClick={() => setOpenOrderChat(false)}>
                        <Close />
                    </IconButton>
                </Grid2>
            </Grid2>
            <Grid2 size='grow'>
                <OrderChat order_id={Number(order_id)} />
            </Grid2>
        </Grid2>
    )
}

export default DashboardOrderChat